define( function() {
	return ( /<([\w:-]+)/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rtagName.js
// module id = 118
// module chunks = 0